import React from "react";
import { Drawer, Tabs } from "antd";
import { ApplyDocumentView } from "./ApplyDocumentView";
const { TabPane } = Tabs;

export interface ApplyDocumentViewItem {
  documentCategory: string; // 試験：１、試験科目：２
  documentFileId: string; // 出願時提出書類(試験別)TBLまたは出願時提出書類(試験科目別)TBLのID
  documentTypeCode: string; // 01:PDF、02:TXT、03、画像
  documentName: string; // 調査書等々
  subjectName: string;
}

interface Props {
  title?: string;
  documents?: ApplyDocumentViewItem[];
  visible: boolean;
  onClose: () => void;
}

export const ApplyDocumentDrawer = ({
  title = "提出書類",
  documents,
  visible,
  onClose,
}: Props) => {
  const [panes, setPanes] = React.useState<any[]>([]);
  const [vTab, setVTab] = React.useState("0");
  React.useEffect(() => {
    // console.log(visible);
    if (visible) {
      const doCreateDocumentPanes = async () => {
        const tabPanes: any[] = [];
        if (documents != null && documents.length > 0) {
          documents.forEach((element, index) => {
            let tabName = `${element.documentName}`;
            if (element.documentCategory === "1") {
              tabName = `[共通] ${element.documentName}`;
            } else {
              tabName = `[科目・${element.subjectName}] ${element.documentName}`;
            }
            tabPanes.push(
              <TabPane tab={tabName} key={index}>
                <ApplyDocumentView viewDocument={element} />
              </TabPane>
            );
          });
        }
        setPanes(tabPanes);
        setVTab("0");
      };
      doCreateDocumentPanes();
    }
    // setDrawerVisible(visible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documents]);

  return (
    <Drawer
      title={title}
      placement="right"
      size={"large"}
      width="1200"
      onClose={onClose}
      visible={visible}
    >
      {panes && panes.length > 0 ? (
        <Tabs
          defaultActiveKey={vTab}
          activeKey={vTab}
          onChange={(activeKey: string) => setVTab(activeKey)}
        >
          {panes}
        </Tabs>
      ) : (
        ""
      )}
    </Drawer>
  );
};
